/**
 * Created by iamso on 22.07.21
 */

const YandexPayments = function () {
    Payments.call(this, connector.YANDEX, {
        sdk: SdkManager.SDK_YANDEX
    });
};

YandexPayments.prototype = Object.create(Payments.prototype);
YandexPayments.prototype.constructor = YandexPayments;

YandexPayments.prototype.getDefaultCurrency = function () {
    return "YAN";
};

YandexPayments.prototype.getProductId = function (product) {
    return product.id.yandex;
};

YandexPayments.prototype._connect = function (callback) {
    ysdk.getPayments({ signed: true }).then((payments) => {
        this.yaPayments = payments;

        callback(connector.STATUS_CONNECTED);
    }).catch((err) => {
        console.log("YandexPayments connect error", err);

        callback(connector.STATUS_DISCONNECTED);
    });
};

YandexPayments.prototype._loadProducts = function (callback) {
    this.yaPayments.getCatalog().then((products) => {
        const loadedIds = products.map((product) => product.id);

        products.forEach(function (product) {
            const ourProduct = this.getProduct(product.id);
            if (ourProduct) {
                ourProduct.price = product.priceValue;
                ourProduct.textPrice = this.getTextPrice(product.priceValue);
                // ourProduct.textPrice = product.price;
                // ourProduct.currency = product.priceCurrencyCode;
                ourProduct.currencyImage = product.getPriceCurrencyImage && product.getPriceCurrencyImage("medium");
            }
        }, this);

        callback(connector.CODE_SUCCEED, loadedIds);
    }).catch((err) => {
        console.log("Failed prices check", err);

        callback(connector.CODE_FAILED);
    });
};

YandexPayments.prototype.purchase = function (product, callback) {
    this.yaPayments.purchase({
        id: product.productId,
        developerPayload: JSON.stringify({
            userId: connector.platform.getUserID(),
            itemId: product.itemId
        })
    }).then((yandexPurchase) => {
        const purchase = this.createPurchase(yandexPurchase.purchaseToken, product, {
            signature: yandexPurchase.signature
        });

        console.log("success", purchase);

        callback(connector.CODE_SUCCEED, purchase);
    }).catch((e) => {
        if (e && e.code === "PAYMENT_USER_CANCELED") {
            callback(ERRORS.PURCHASE.CANCEL);
            return;
        }

        console.log("error", e);
        callback(ERRORS.PURCHASE.UNKNOWN, undefined, { error: e && e.code, message: e && e.message });

        this.bus.trigger("stream:error", `YandexPayments.purchase ${product.productId}`, e);
    });
};

YandexPayments.prototype.consume = function (purchase, callback) {
    // console.log("consume start", purchase);

    this.yaPayments.consumePurchase(purchase.paymentId).then(() => {
        console.log("consume success", purchase);
        callback(connector.CODE_SUCCEED);
    }).catch((e) => {
        this.bus.trigger("stream:error", "YandexPayments.consume", e);

        console.log("consume error", e);
        callback(ERRORS.CONSUME.UNKNOWN);
    });
};

YandexPayments.prototype.restore = function (callback) {
    this.yaPayments.getPurchases().then((purchases) => {
        console.log("getPurchases", purchases);

        if (purchases.length === 0) {
            callback(connector.CODE_FAILED);
            return;
        }

        const yandexPurchase = purchases[0];

        const productId = JSON.parse(yandexPurchase.developerPayload).itemId;

        const product = this.getProduct(productId);

        const purchase = this.createPurchase(yandexPurchase.purchaseToken, product, {
            signature: purchases.signature
        });

        callback(connector.CODE_SUCCEED, purchase);
    }).catch((e) => {
        this.bus.trigger("stream:error", "YandexPayments.restore", e);

        callback(connector.CODE_FAILED);

        console.log("error getPurchases", e);
    });
};

YandexPayments.prototype.validate = function (purchase, callback) {
    const data = {
        purchase,
        version: 2
    };

    ConnectorRestClient.post("/yandexpayments/validate", data, (res) => {
        const code = res === "ok" ? connector.CODE_SUCCEED : connector.CODE_FAILED;
        callback(code, purchase);
    }, () => {
        callback(connector.CODE_SUCCEED, purchase);
    });
};

YandexPayments.isAppropriate = function () {
    return connector.platform.oneOf(connector.YANDEX);
};
